import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import classNames from 'classnames'

import assetsPath from '../../../../common/utils/assetsPath'

import styles from './signIn.module.css'

const SignInModal = ({
  showReCAPTCHA,
  show2FA,
  showUsernameMissing,
  showPasswordMissing,
  showServerError,
  showLoading,
  data,
  passwordErrorMsg,
  twoFAErrorMsg,
  openModalData,
  onSubmit,
  onInputChange,
  onReCAPTCHAChange,
  recaptchaKey
}) => {
  const {
    welcomeMsg,
    welcomeMsgDescription
  } = openModalData
  const logoAssetsPath = `${assetsPath()}/images/envato_white.svg`
  const modalClassNames = classNames(
    'fds-c-modal',
    '-width-s',
    {
      'is-disabled-loading': showLoading
    }
  )

  // apply invalid status to form when either is missing or wrong details
  const usernameInputStatus = showUsernameMissing || passwordErrorMsg
    ? 'invalid'
    : null
  const passwordInputStatus = showPasswordMissing || passwordErrorMsg
    ? 'invalid'
    : null
  const twoFAInputStats = twoFAErrorMsg
    ? 'invalid'
    : null

  return (
    <div className={modalClassNames}>
      <header className='fds-c-modal__header fds-u-text-align-center fds-c-modal__section -background-dark'>
        <div className='fds-u-py1'>
          <img
            alt='Envato'
            width='130'
            src={logoAssetsPath}
          />
        </div>
      </header>

      <div className='fds-c-modal__section -radius-bottom'>
        { welcomeMsg &&
          <h2 className='fds-c-text-heading fds-u-text-align-center -size-s fds-u-mb0 fds-u-pt2 fds-u-pb2'>{welcomeMsg}</h2>
        }
        { welcomeMsgDescription &&
          <p className='fds-c-text-body fds-u-text-align-center -size-s fds-u-mb0 fds-u-pb2'>{welcomeMsgDescription}</p>
        }
        <form
          acceptCharset='UTF-8'
          onSubmit={onSubmit}
          className='fds-c-form -layout-vertical-inline'
          noValidate
        >
          <div className='fds-c-form__group fds-u-text-align-center'>
            <div className={styles.formLabelInlineGroup}>
              <div className={styles.formLabel}>
                <span>Username</span>
              </div>
              <div>
                <a
                  className='fds-c-text-link -decoration-none'
                  href='https://account.envato.com/recover_usernames'
                >
                  Remind me
                </a>
              </div>
            </div>
            <div className='fds-c-form__input'>
              <input
                autoFocus
                tabIndex={1}
                data-status={usernameInputStatus}
                defaultValue={data.username}
                onChange={onInputChange('username')}
                name='username'
                className='fds-c-form-input -type-string'
                size='50'
                type='text'
                required
              />
            </div>
            { showUsernameMissing &&
              <div id='missing-username' className={styles.formResponse}>
                Username is required
              </div>
            }
          </div>

          <div className='fds-c-form__group fds-u-text-align-center'>
            <div className={styles.formLabelInlineGroup}>
              <div className={styles.formLabel}>
                <span>Password</span>
              </div>
              <div>
                <a
                  className='fds-c-text-link -decoration-none'
                  href='https://account.envato.com/reset_password'
                >
                  Reset
                </a>
              </div>
            </div>
            <div className='fds-c-form__input'>
              <input
                tabIndex={2}
                data-status={passwordInputStatus}
                defaultValue={data.password}
                onChange={onInputChange('password')}
                name='password'
                className='fds-c-form-input -type-string'
                size='50'
                type='password'
                required
              />
            </div>
            { showPasswordMissing &&
              <div id='missing-password' className={styles.formResponse}>
                Password is required
              </div>
            }
            { passwordErrorMsg &&
              <div id='password-error' className='fds-c-form__response'>
                {passwordErrorMsg}
              </div>
            }
          </div>

          { showReCAPTCHA &&
            <div id='recaptcha' className='fds-c-form__group'>
              <div className={styles.captcha}>
                <ReCAPTCHA
                  sitekey={recaptchaKey}
                  onChange={onReCAPTCHAChange}
                />
              </div>
            </div>
          }

          { show2FA &&
            <div id='two-fa' className='fds-c-form__group'>
              <div className={styles.formLabelInlineGroup}>
                <div className={styles.formLabel}>Authentication Code</div>
              </div>

              <div className='fds-c-form__input fds-u-text-align-center'>
                <input
                  data-status={twoFAInputStats}
                  defaultValue={data.authentication_code}
                  onChange={onInputChange('authentication_code')}
                  name='twoFactor'
                  className='fds-c-form-input -type-string'
                  size='50'
                  type='text'
                />
              </div>
              { twoFAErrorMsg &&
                <div className='fds-c-form__response fds-u-text-align-center'>{twoFAErrorMsg}</div>
              }
            </div>
          }

          { showServerError &&
            <div id='server-error' className='fds-c-form__group  fds-u-text-align-center'>
              <div className='fds-c-form__response'>
                Whoops! Something went wrong.
                <br />
                Please try again or sign in via this <a href='https://account.envato.com/'>link</a>.
              </div>
            </div>
          }

          <p className='fds-u-text-align-center'>
            <button
              tabIndex={3}
              disabled={showLoading}
              type='submit'
              className='fds-c-button--3d -color-primary -size-m'
            >
              Sign in to your account
            </button>
          </p>

          <p className='fds-u-text-align-center fds-u-mt2 fds-u-mb3'>
            New here? { ' ' }
            <a
              className='fds-c-text-link -decoration-none'
              href='https://account.envato.com/'
            >
              Create an Envato account
            </a>
          </p>
        </form>
      </div>
    </div>
  )
}

export default SignInModal



// WEBPACK FOOTER //
// ./client/components/modals/user/signIn.js